import { configureStore } from "@reduxjs/toolkit";
import reducer from "./slices";

export const storeTWO = configureStore({
  reducer,
});
